import { S } from '../strings';

export function BookmarkStar({
  active,
  onToggle,
}: {
  active: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-label={active ? S.bookmark.remove : S.bookmark.add}
      title={active ? S.bookmark.remove : S.bookmark.add}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 2,
        fontSize: 15,
        lineHeight: 1,
        color: active ? '#B8881F' : 'var(--text-muted)',
        transition: 'color 0.15s',
      }}
    >
      {active ? '★' : '☆'}
    </button>
  );
}
